import React, { useState, useEffect } from "react";
import Carousel from "react-multi-carousel";

const CustomDot = ({ onClick, active, index, carouselState }) => {
	const { currentSlide, slidesToShow, totalItems } = carouselState;

	return slidesToShow === totalItems ? (
		""
	) : (
		<li
			data-index={index}
			className={`react-multi-carousel-dot ${
				active ? "react-multi-carousel-dot--active" : ""
			}`}
			aria-controls={`simple-carousel-${index}`}
			aria-label={`Carousel Item ${index}`}
		>
			<button
				aria-label={`Go to slide ${index}`}
				// className={`simple-carousel-dot ${active ? "active" : ""}`}
				onClick={() => onClick()}
			></button>
		</li>
	);
};

const CustomButtonGroupAsArrows = ({ next, previous, carouselState }) => {
	const { slidesToShow, totalItems } = carouselState;

	return slidesToShow >= totalItems ? (
		""
	) : (
		<div
			className="carousel-btn-wrapper carousel-btn-wrapper--alt"
			style={{ width: totalItems * 55 + 80 + "px" }}
		>
			<button className="carousel-btn-prev" onClick={previous}></button>
			<button className="carousel-btn-next" onClick={next}></button>
		</div>
	);
};

export default function SimpleCarouselWrapper({
	simpleCarouselHTML = [],
	autoscroll = false,
}) {
	const responsive = {
		desktop: {
			breakpoint: { max: 5000, min: 0 },
			items: 1,
		},
	};
	return simpleCarouselHTML && simpleCarouselHTML.length ? (
		<Carousel
			responsive={responsive}
			renderDotsOutside
			showDots
			customDot={<CustomDot />}
			arrows={false}
			autoPlay={autoscroll}
			autoPlaySpeed={8000}
			infinite={autoscroll}
			renderButtonGroupOutside
			customButtonGroup={<CustomButtonGroupAsArrows />}
		>
			{simpleCarouselHTML.map((elem, i) => {
				return (
					<div
						key={i}
						dangerouslySetInnerHTML={{ __html: elem.innerHTML }}
					></div>
				);
			})}
		</Carousel>
	) : null;
}
